{
  "translatedFrom": "Tradus din {{lang}} — vezi originalul",
  "originalShown": "Original ({{lang}}) — vezi traducerea",
  "translationPending": "Original ({{lang}}) — traducere în așteptare",
  "allSourcesRetired": "Toate sursele retrase",
  "unknown": "Necunoscut",
  "sourcesCount_one": "{{count}} sursă",
  "sourcesCount_few": "{{count}} surse",
  "sourcesCount_other": "{{count}} de surse",
  "retiredCount_one": "{{count}} retrasă",
  "retiredCount_few": "{{count}} retrase",
  "retiredCount_other": "{{count}} de retrase",
  "workflowRetired": "RETRAS — nu mai este disponibil",
  "interested": "Interesat",
  "notInterested": "Neinteresat",
  "visit": "Vizionare:",
  "address": "Adresă:",
  "comment": "Comentariu:",
  "list": {
    "noAdsTitle": "Niciun anunț disponibil",
    "noAdsSubtitle": "Reveniți mai târziu pentru anunțuri noi care corespund criteriilor dumneavoastră.",
    "count_one": "{{count}} proprietate găsită",
    "count_few": "{{count}} proprietăți găsite",
    "count_other": "{{count}} de proprietăți găsite"
  },
  "map": {
    "notAvailable": "Harta nu este disponibilă — adresa nu a putut fi geocodificată",
    "propertyLocation": "Locația proprietății"
  },
  "sources": {
    "failedToLoad": "Încărcarea surselor a eșuat",
    "failedToUnmerge": "Separarea sursei a eșuat",
    "activeSources": "Surse active",
    "multipleSourcesHint": "Acest anunț a fost găsit pe mai multe site-uri. Sursa principală furnizează detaliile anunțului.",
    "singleSourceHint": "Sursa curentă pentru acest anunț.",
    "retiredSources": "Surse retrase",
    "retiredHint": "Aceste surse nu mai sunt disponibile pe site-urile lor.",
    "primary": "Principală",
    "primaryForced": "Forțată",
    "priceDiffers": "Preț diferit",
    "view": "Vezi",
    "retiredDetail": "Retrasă: {{retiredDate}} | Importată: {{importDate}}",
    "activeDetail": "Văzută ultima dată: {{lastSeenDate}} | Importată: {{importDate}}",
    "unmergeTooltip": "Separă această sursă într-un anunț distinct",
    "unmergeDialogTitle": "Separă sursa?",
    "unmergeDialogBody": "Această acțiune va separa sursa de la {{website}} într-un anunț distinct. Anunțul original își va păstra celelalte surse.",
    "unmerge": "Separă",
    "setPrimaryTooltip": "Setează ca sursă principală",
    "resetToAutomaticTooltip": "Revino la sursa principală automată",
    "failedToSetPrimary": "Setarea sursei principale a eșuat",
    "failedToResetPrimary": "Resetarea sursei principale a eșuat"
  },
  "mortgage": {
    "title": "Simulare credit ipotecar",
    "resetToDefaults": "Resetează la valorile implicite",
    "noPriceError": "Anunțul nu are un preț pentru a simula un credit ipotecar",
    "recalculateError": "Recalcularea creditului ipotecar a eșuat",
    "resetError": "Resetarea simulării ipotecare a eșuat",
    "page": {
      "title": "Simulator ipotecar",
      "loadError": "Încărcarea simulării ipotecare a eșuat"
    },
    "warnings": {
      "INSUFFICIENT_EQUITY": "Capital propriu insuficient: avansul este sub ponderea minimă recomandată din prețul de achiziție.",
      "DOWN_PAYMENT_COVERS_PRICE": "Avansul acoperă integral prețul de achiziție — nu este necesar niciun credit.",
      "EFFORT_RATIO_EXCEEDED": "Rata de efort depășește ponderea maximă recomandată din venitul gospodăriei."
    },
    "fields": {
      "price": "Preț de achiziție (CHF)",
      "down_payment": "Avans (CHF)",
      "interest_rate": "Rata dobânzii (%)",
      "term_years": "Perioadă fixă (ani)",
      "maintenance_rate": "Întreținere și cheltuieli (%)",
      "purchase_costs_rate": "Costuri de achiziție (%)",
      "amortization_target_ltv": "LTV țintă de amortizare (%)",
      "amortization_years": "Perioadă de amortizare (ani)",
      "stress_test_rate": "Rata testului de stres (%)",
      "max_effort_ratio": "Rata maximă de efort (%)",
      "annual_income": "Venitul anual al gospodăriei (CHF)"
    },
    "downPayment": {
      "title": "Avans",
      "percentLabel": "Procent din preț (%)",
      "helper": "Min {{minPercent}} = {{minAmount}} · Max {{maxAmount}}",
      "sliderAria": "Ajustează suma cu ajutorul cursorului"
    },
    "results": {
      "loan_amount": "Suma creditului",
      "ltv": "Raport credit/valoare (LTV)",
      "total_cash_needed": "Total lichidități necesare",
      "annual_interest": "Dobândă anuală",
      "annual_amortization": "Amortizare anuală",
      "annual_maintenance": "Întreținere anuală",
      "annual_cost": "Cost anual",
      "monthly_cost": "Cost lunar",
      "theoretical_annual_cost": "Cost anual teoretic (test de stres)",
      "required_income": "Venit anual necesar",
      "effort_ratio": "Rata de efort",
      "total_interest_over_term": "Dobândă totală pe perioada fixă"
    },
    "charts": {
      "fundingTitle": "Structura finanțării",
      "monthlyTitle": "Defalcarea costului lunar",
      "effortTitle": "Indicator rata de efort",
      "segments": {
        "downPayment": "Avans",
        "loanAmount": "Suma creditului",
        "purchaseCosts": "Costuri de achiziție",
        "interest": "Dobândă",
        "amortization": "Amortizare",
        "maintenance": "Întreținere"
      },
      "includePurchaseCosts": "Include costurile de achiziție",
      "titleWithTotal": "{{title}} ({{total}})",
      "amortizationNote": "Amortizarea construiește capital propriu în proprietate, nu este un cost pur.",
      "effortNote": "Bazat pe costul teoretic al testului de stres, nu pe costul lunar real de mai sus.",
      "maxEffortMarker": "Maxim recomandat: {{value}}"
    }
  },
  "page": {
    "title": "Anunțuri imobiliare",
    "subtitle": "Răsfoiți și gestionați anunțurile imobiliare care corespund criteriilor dumneavoastră",
    "criteriaSet": "Set de criterii",
    "allCriteriaUnion": "Toate criteriile (uniune)",
    "loadingAds": "Se încarcă anunțurile...",
    "failedToLoadTitle": "Încărcarea anunțurilor a eșuat",
    "untitled": "Fără titlu",
    "noAdsInStage": "Niciun anunț în această etapă încă.",
    "retiredTab": "Retras",
    "scheduleVisit": "Programează vizionare",
    "discard": "Respinge",
    "markVisited": "Marchează ca vizionat",
    "markBought": "Marchează ca cumpărat",
    "markAsVisitedTitle": "Marchează ca vizionat",
    "markAsVisitedDescription": "Introduceți comentariile dumneavoastră despre vizionare.",
    "discardAdTitle": "Respinge anunțul",
    "discardAdDescription": "Introduceți motivul pentru care respingeți acest anunț.",
    "markAsBoughtTitle": "Marchează ca cumpărat",
    "markAsInterestedToBuyTitle": "Marchează ca interesat pentru cumpărare",
    "confirmBoughtMessage": "Sigur doriți să marcați această proprietate ca fiind cumpărată?",
    "confirmInterestedToBuyMessage": "Sigur doriți să marcați această proprietate ca fiind interesat pentru cumpărare?",
    "notInterestedTitle": "Neinteresat - Adaugă comentariu",
    "notInterestedDescription": "Introduceți motivul pentru care nu sunteți interesat de această proprietate."
  },
  "detail": {
    "moveToRetired": "Trece la retras",
    "allSourcesRetiredTitle": "Toate sursele acestui anunț au fost retrase",
    "allSourcesRetiredMessage": "Acest anunț nu mai este disponibil pe niciun site. Îl puteți trece doar la starea retras.",
    "priceMismatchTitle": "Sursele nu sunt de acord asupra prețului",
    "priceMismatchMessage": "Una sau mai multe surse secundare indică un preț diferit de cel afișat aici. Vezi „Toate sursele” mai jos pentru detalii.",
    "priceLabel": "Preț",
    "sizeLabel": "Suprafață",
    "roomsLabel": "Camere",
    "addressHeading": "Adresă",
    "edited": "Editată",
    "editAddress": "Editează adresa",
    "matchingCriteria": "Criterii corespunzătoare",
    "description": "Descriere",
    "additionalDetails": "Detalii suplimentare",
    "floor": "Etaj:",
    "yearBuilt": "An construcție:",
    "propertyType": "Tip proprietate:",
    "status": "Stare:",
    "visitDate": "Data vizionării:",
    "visitAddress": "Adresa vizionării:",
    "source": "Sursă",
    "viewOriginal": "Vezi originalul",
    "dates": "Date",
    "imported": "Importat: {{date}}",
    "comments": "Comentarii",
    "addComment": "Adaugă comentariu",
    "noComments": "Niciun comentariu încă.",
    "statusHistory": "Istoric stare",
    "noStatusChanges": "Nicio schimbare de stare încă.",
    "addressUpdated": "Adresă actualizată",
    "addressUpdateFailed": "Actualizarea adresei a eșuat",
    "flaggedInterested": "Anunț marcat ca interesant!",
    "flagFailed": "Marcarea anunțului a eșuat",
    "flaggedNotInterested": "Anunț marcat ca neinteresant",
    "statusUpdated": "Stare actualizată!",
    "actionFailed": "Acțiunea a eșuat",
    "commentAdded": "Comentariu adăugat!",
    "commentAddFailed": "Adăugarea comentariului a eșuat",
    "markAsVisitedDescription": "Adăugați un comentariu despre vizionare.",
    "addCommentDialogDescription": "Adăugați un comentariu la fluxul acestei proprietăți.",
    "statusComment": "Comentariu:",
    "editVisitDate": "Editează data vizionării",
    "editVisitAddress": "Editează adresa vizionării",
    "editStatusComment": "Editează comentariul",
    "addVisitDate": "Adaugă data vizionării",
    "addVisitAddress": "Adaugă adresa vizionării",
    "addStatusComment": "Adaugă comentariu de stare",
    "visitDateUpdated": "Data vizionării a fost actualizată",
    "visitDateUpdateFailed": "Actualizarea datei vizionării a eșuat",
    "visitAddressUpdated": "Adresa vizionării a fost actualizată",
    "visitAddressUpdateFailed": "Actualizarea adresei vizionării a eșuat",
    "statusCommentUpdated": "Comentariu actualizat",
    "statusCommentUpdateFailed": "Actualizarea comentariului a eșuat",
    "editedBy": "Editat de {{user}}, {{time}}",
    "fieldChanges": "Modificări de câmpuri",
    "noFieldChanges": "Nicio modificare de câmp încă.",
    "fieldChangeValue": "{{oldValue}} → {{newValue}}",
    "fieldChangeEmpty": "(gol)",
    "fieldNames": {
      "address": "Adresă",
      "visit_date": "Data vizionării",
      "visit_address": "Adresa vizionării",
      "status_comment": "Comentariu",
      "primary_source": "Sursa principală"
    },
    "deleteAd": "Șterge",
    "deleteAdTitle": "Ștergi acest anunț?",
    "deleteAdMessage": "„{{title}}” și tot ce este legat de el (surse, flux de lucru, comentarii, istoric) vor fi șterse definitiv. Dacă anunțul este încă online, scraperul îl poate reimporta la următoarea rulare.",
    "adDeleted": "Anunț șters",
    "deleteFailed": "Ștergerea anunțului a eșuat"
  }
}
